
import {filter} from 'rxjs/operators';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { TrackingActions } from '../../state-management/tracking/tracking.action';
import { AppState } from '../../interfaces/app-state.interface';
import { MyCapitalKeys } from '../../models/mycapital/mycapital-model';
import { MyCapitalService } from '../../services/mycapital/mycapital.service';
import { UserProfileService } from '../../services/users/user-profile.service';
import { MyCapitalActions } from '../../state-management/mycapital/mycapital.action';
import { PlatformsAcceptanceAction } from '../../state-management/platforms-acceptance/platforms-acceptance.action';
import { environment } from '../../../src/environments/environment'

@Component({
    selector: 'modal-terms-section',
    templateUrl: './modal-terms-section.component.html',
    styleUrls: ['./modal-terms-section.component.scss'],
})
export class ModalTermsSectionComponent implements OnInit, OnChanges {
    public isNewBrand: boolean = environment.isNewBrand
    @Input() public clickDialog: boolean;
    @Output() public emitter = new EventEmitter();

    public myCapitalKeys = {} as MyCapitalKeys;
    public userRegistred: boolean = false;
    public openDialog: boolean = false;
    private disposableSubscriptions: Subscription[] = [];

    constructor(
        protected store: Store<AppState>,
        protected myCapitalService: MyCapitalService,
        protected userProfileService: UserProfileService,
    ) {}

    public ngOnInit() {
        this.bindPlatformsAcceptance();
        this.bindMyCapitalKeys();
    }

    public bindMyCapitalKeys() {
        this.store.dispatch({type: MyCapitalActions.getMyCapitalKeys});
        this.store.select((state) => state.myCapitalKeys).pipe(
                filter((myCapitalKeys) => myCapitalKeys.keysHasValue))
                .subscribe((myCapitalKeys) => {
                    this.myCapitalKeys = myCapitalKeys.keys;
                });
    }

    public bindPlatformsAcceptance() {
        this.store.dispatch({ type: PlatformsAcceptanceAction.getDataTransferAcceptance, payload: 'mycapital' });

        this.disposableSubscriptions.push(
            this.store.select((state) => state.platformsAcceptance).pipe(
                filter((platformAcceptance) => !platformAcceptance.pending))
                .subscribe((platformAcceptance) => {
                    if(platformAcceptance.result && this.myCapitalKeys) {
                        this.userRegistred = true;
                    }
                }),
        );
    }

    public dispatchSetAcceptance() {
        this.store.dispatch({ type: PlatformsAcceptanceAction.setDataTransferAcceptance, payload: 'mycapital' });
    }

    public ngOnChanges(changes) {
        if(this.clickDialog) {
            if(this.userRegistred) {
                this.trackRedirectEvent();
                this.redirectToMycapital();
            } else {
                this.trackOpenDialogEvent();
                this.openDialog = true;
            }
        }
    }

    public closeDialog() {
        this.trackCloseEvent();
        this.emitCloseEvent();
    }

    public saveAndRedirect() {
        this.dispatchSetAcceptance();
        this.trackAcceptEvent();
        this.redirectToMycapital();
    }

    public emitCloseEvent(){
        this.openDialog = false;
        this.clickDialog = false;
        this.emitter.emit(this.clickDialog);
    }

    // Redireciona usuário para mycapital
    public redirectToMycapital() {
        if (this.myCapitalKeys) {
            this.emitCloseEvent();
            window.open(this.myCapitalService.getUrl(this.myCapitalKeys), '_blank');
        }
    }

    private trackAcceptEvent(){
        this.sendToTracking('CTA ir para My Capital');
    }

    private trackRedirectEvent(){
        this.sendToTracking('Acessar calculadora de IR')
    }

    private trackCloseEvent(){
        this.sendToTracking('Fechar modal My Capital');
    }

    private trackOpenDialogEvent(){
        this.sendToTracking('Modal de aceite calculadora IR');
    }

    private sendToTracking(element: string) {
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: {
                type: `User Clicked`,
                events: {
                    origin: this.clickOrigin,
                    element: element,
                    cblc: this.myCapitalKeys.chave1
                },
            },
        });
    }

    private get clickOrigin(){
        switch (window.location.pathname) {
            case '/bolsa/meus-investimentos':
                return 'Meus investimentos';
            case '/plataformas/calculadora-de-ir':
                return 'LP My Capital';
            case '/minha-conta/plataformas':
                return 'Minha Conta Plataformas';
            case '/minha-conta/imposto':
                return 'Minha Conta IR';
            default:
                return window.location.pathname;
        }
    }
}
